import { render, staticRenderFns } from "./JwJiaocaiSupplierModal.vue?vue&type=template&id=bf624088"
import script from "./JwJiaocaiSupplierModal.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiSupplierModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports